export function getSessionUser() {
  try {
    return JSON.parse(sessionStorage.getItem('user'));
  } catch {
    return null;
  }
}

export function isSystemAdmin(user) {
  if (!user) return false;
  return user.role === 'System Admin' || user.role_name === 'System Admin';
}

function isContractPartyAdminUser(user) {
  if (!user) return false;
  return user.role === 'Contract Party Admin' || user.role_name === 'Contract Party Admin';
}

function isHubAdminUser(user) {
  if (!user) return false;
  return user.role === 'Hub Admin' || user.role_name === 'Hub Admin';
}

function getUserRoleName(user) {
  return user?.role_name || user?.role || '';
}

export function companiesMatch(record, currentUser) {
  if (!record || !currentUser) return false;

  const recordCode = record.company_id ?? record.companyId;
  const userCode = currentUser.company_id;
  if (recordCode != null && userCode != null && String(recordCode) === String(userCode)) {
    return true;
  }

  const recordInternal = record.company_internal_id;
  const userInternal = currentUser.company_internal_id;
  if (recordInternal != null && userInternal != null) {
    return String(recordInternal) === String(userInternal);
  }

  return false;
}

export function canAccessCompanyRecord(record, currentUser = getSessionUser()) {
  if (!record || !currentUser) return false;
  if (isSystemAdmin(currentUser)) return true;
  return companiesMatch(record, currentUser);
}

/** Company + role/party rules for viewing a user record. */
export function canAccessUserRecord(record, currentUser = getSessionUser()) {
  if (!record || !currentUser) return false;
  if (isSystemAdmin(currentUser)) return true;
  if (!companiesMatch(record, currentUser)) return false;

  if (isContractPartyAdminUser(currentUser)) {
    if (String(record.user_id) === String(currentUser.user_id)) return true;
    if (record.role_name !== 'Agent') return false;
    if (currentUser.party_id == null || record.party_id == null) return false;
    return String(record.party_id) === String(currentUser.party_id);
  }

  if (isHubAdminUser(currentUser)) {
    if (String(record.user_id) === String(currentUser.user_id)) return true;
    if (record.role_name !== 'Agent') return false;
    if (currentUser.location_hub_id == null || record.location_hub_id == null) return false;
    return String(record.location_hub_id) === String(currentUser.location_hub_id);
  }

  return true;
}

/** Same company scope as view, plus role-based edit restrictions. */
export function canEditUserRecord(record, currentUser = getSessionUser()) {
  if (!canAccessUserRecord(record, currentUser)) return false;

  const editorRole = getUserRoleName(currentUser);
  const targetRole = record.role_name || record.role || '';

  // Admin / Accountant: cannot edit System Admin; cannot edit other Admins (self OK)
  if (editorRole === 'Admin' || editorRole === 'Accountant') {
    if (targetRole === 'System Admin') return false;
    if (targetRole === 'Admin' && String(record.user_id) !== String(currentUser.user_id)) {
      return false;
    }
  }

  return true;
}

export function getAuthToken() {
  const user = getSessionUser();
  return user?.token || null;
}
